
export function expertiseGridClassName(isDesktop) {
	return [
		"grid w-full justify-items-center",
		isDesktop ? "grid-cols-8 gap-x-1 gap-y-4" : "grid-cols-4 gap-x-0 gap-y-5",
	].join(" ");
}
